import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Job } from '@shared';
import { JobStatusEnum } from '@shared/models/job-statuses';

@Component({
  selector: 'mojo-jobs-form-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],

  // TODO: add custom change emitter on validation
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobStatusFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() job: Partial<Job>;

  statusList = Object.values(JobStatusEnum);
}
